export enum TipoEntrega {
    DeliveryOuRetirarNoLocal = 0,
    RetirarNoLocal = 1,
    Delivery = 2
}